
<template>
    <div id="VehicleList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Transfer List</div>
                    <div class="web-action-btn btn-groups text-right">
                        <button v-if="canExportRequest == true" type="button" class="btn btn-secondary" v-on:click="exportReports()" >
                        <i class="fp-export"></i> Export
                        </button>
                        <router-link v-if="canMakeRequest == true" class="btn btn-primary" v-bind:to="{name: 'TransportRequestForm', params:{flag:'form'}}" > <i class="fp-add"> </i> Add</router-link>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li><a v-if="canExportRequest" v-on:click="exportReports()">Export</a> </li>
                                <li><router-link v-if="canMakeRequest" v-bind:to="{name: 'TransportRequestForm', params:{flag:'form'}}">  Add</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content transport-request-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'transportRequestList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange" :moduleName="'transportRequestList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                          ref="listTransportRequest"
                                          mode="remote"
                                          title="Request Form"
                                          @on-page-change="onPageChange"
                                          @on-selected-rows-change="selectionChanged"
                                          @on-column-filter="onColumnFilter"
                                          @on-per-page-change="onPerPageChange"
                                          @on-sort-change="onSortChange"
                                          :totalRows="totalRecords"
                                          :columns="userColumns"
                                          :rows="rows"
                                          :pagination-options="{
                                              enabled: false,
                                              position: 'both',
                                              perPage: perPage,
                                              perPageDropdown:dropDownPerPage,
                                              dropdownAllowAll: false,
                                          }"

                                          :search-options="{
                                      enabled: false,
                                      }">
                                      <div slot="selected-row-actions">
                                          <button v-if="canRemoveRequest" id="deleteGroupBtn" v-on:click.prevent="deleteTransportRequestData" class="btn btn-primary">Delete</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
    import Vue from "vue";

    
    
    import EventBus from "./../event-bus";


    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "VehicleList",
        metaInfo() {
            return {
                title: "Transport Request List | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            userColumns:[],
            permissions: [],
            cantAccessPage: "",
            columns: [
                {
                    label: 'Requested Name',
                    field: 'requested_by',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Requested Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Requested Date',
                    field: 'requested_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Unit',
                    field: 'unit_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer Name',
                    field: 'customer_name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Pickup Location',
                    field: 'pick_location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Pickup Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Pickup Address',
                    field: 'pick_address',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Pickup Address", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Delivery Location',
                    field: 'delivery_location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Delivery Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Delivery Address',
                    field: 'delivery_address',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Delivery Address", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Who are we billing?',
                    field: 'billing',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Customer', 'Skip'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: '#RS or #WO',
                    field: 'rs_wo',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "#RS or #WO", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Who is transporting?',
                    field: 'transporting',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Internal', 'External'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'How will they get back?',
                    field: 'get_back',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Lyft', 'Truck Back'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Approval#',
                    field: 'approval_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Approval#", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Comments',
                    field: 'comments',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Comments", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },


            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            canExportRequest:false,
            canMakeRequest:false,
            canRemoveRequest:false,
            action:'list',
            batchProcess:0,
            batchNum:"",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'transport_request_list') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'export_transport_request') {
                            self.canExportRequest = true;
                        }
                        if (permissions[i].name == 'transport_request') {
                            self.canMakeRequest = true;
                        }
                        if (permissions[i].name == 'delete_transport_request') {
                            self.canRemoveRequest = true;
                        }
                    }
                }
            }
        },
        created: function() {

        },

        mounted: function() {
            var self = this;

            //self.loadList('list);
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listTransportRequest.unselectAllInternal();
            },

            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList('list');
            },
            onPerPageChange(params) {
                this.serverParams.page = 1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList('list');
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('unit_no');
                    field:('requested_date');
                    field:('customer_name');
                    field:('requested_by');
                    field:('pick_location');
                    field:('pick_address');
                    field:('delivery_location');
                    field:('delivery_address');
                    field:('billing');
                    field:('rs_wo');
                    field:('get_back');
                    field:('approval_no');
                    field:('transporting');
                    field:('comments');

                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.unit_no || filters.group || filters.vin || filters.status || filters.equipment_type || filters.location || filters.purchase_date || filters.date_in_service) {
                    this.loadList('list');
                }
            },*/
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList('list');
            },*/
            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    list_flag: self.action,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/transport_request_form/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if(self.action == 'list') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                            if ( self.action == "export" ||  self.action == "export_queue")  {

                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";
                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);
                                    } else {
                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if(self.action != 'export') {
                            self.generateStatusCodeMessage(jqXHR, false, 'transport-req-delete')
                        }else{
                            self.generateStatusCodeMessage(jqXHR, false, 'transport-req-list')
                        }

                    }
                });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/TransportRequestForm/TransportRequestFormList.vue